import { render } from "./ModalConsultarHistorico.vue?vue&type=template&id=28722689&scoped=true"
import script from "./ModalConsultarHistorico.vue?vue&type=script&lang=js"
export * from "./ModalConsultarHistorico.vue?vue&type=script&lang=js"

import "./ModalConsultarHistorico.vue?vue&type=style&index=0&id=28722689&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28722689"]])

export default __exports__